<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 27/9/2020
  -->

<template>
	<div>
		<PagerListLayout
			ref="pagerListLayout"
			:menu-items="menuItemsFn"
			:pager-provider="agreementsPagerTemplateProvider"
			@onItemClicked="onTemplateClicked"
			@menuItemClicked="menuItemClicked">

			<template #item-title="{item}">

				<LegalDocTemplateRow
					:legal-doc-template="item"/>


				<div v-if="item._isProcessing" class="">
					<small class="text-muted">
						Processing, please wait...
						<i class="fontello icon-spin5"></i>
					</small>
				</div>
			</template>

			<template #header>

				<div class="text-right">
					<PickFileButton
						@fileSelected="onFileLoaded"
						:filter="fileFilter"
						:filterNames="fileFilterNames"
						:isLoading="templateProcessingInProgress">
						<span v-if="templateProcessingInProgress">
							Processing...
						</span>
						<span v-else>
							+ Upload PDF Agreement
						</span>
					</PickFileButton>
					<hr class="mb-0"/>
				</div>
			</template>

			<template #empty-view>
				<qw-empty>
					<template #title>No Saved Agreement Templates.</template>
					<template #sub-title>
						<div>Save time on documents that need to be signed by multiple clients.</div>
						<div>Add signer fields to your document, save it as a template, and reuse it with a single click.</div>
					</template>

					<template #button>
						<PickFileButton
							@fileSelected="onFileLoaded"
							:filter="fileFilter"
							:filterNames="fileFilterNames"
							:isLoading="templateProcessingInProgress">

							<span v-if="templateProcessingInProgress">
								Processing...
							</span>
							<span v-else>
							+ Upload PDF Agreement
							</span>
						</PickFileButton>
					</template>


				</qw-empty>
			</template>

		</PagerListLayout>
		<LoadingIndicator/>
	</div>


</template>

<script>

import PickFileButton from "@/core/components/File/PickFileButton.vue";
import {editContractDialog} from "@/core/modules/DocSign/data/dialogs/dialog";
import DocSignTemplateItem from "@/core/modules/DocSign/data/DocSignTemplateItem";

import BaseComponent from "@/core/components/BaseComponent.vue";
import {deleteConfirmDialog, messageDialog, textInputDialog} from "@/core/components/Dialogs/dialog";
import PagerListLayout from "@/core/components/PagerListLayout.vue";
import MenuItem from "@/core/modules/coach/Resources/Files/QwoachDrive/MenuItem";
import {MenuAction} from "@/core/modules/coach/Resources/Files/QwoachDrive/MenuAction";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import RequestSignatureFlowHelper from "@/core/modules/DocSign/RequestSignatureFlowHelper";
import LegalDocTemplateRow from "@/core/modules/DocSign/view/LegalDocTemplateRow.vue";
import DataFilterOrderBy from "@/core/js/backend/filters/DataFilterOrderBy.js";
import TeamAssignManager from "@shared/TeamAssignManager.js";



export default {
	extends: BaseComponent,
	name: "AgreementTemplatePickerView",
	components: {LegalDocTemplateRow, ToolTipView, LoadingIndicator, PagerListLayout, PickFileButton},
	props: {
		menuItems: {
			Array, default: () => [
				new MenuItem(MenuAction.SELECT, "Select", null, false, true),
				MenuItem.createEditItem({title: "Edit Template", showAsAction: true}),
				MenuItem.createDeleteItem({showAsAction: true}),
			]
		},
	},
	data() {
		return {
			requestSignatureFlowHelper: new RequestSignatureFlowHelper(),
			templateProcessingInProgressData: false,
			fileFilter: ['.pdf', 'pdf', 'application/pdf'],
			fileFilterNames: ['pdf'],
			teamAssignManager: null,
		}
	},

	created() {
		this.teamAssignManager = new TeamAssignManager(this)
	},

	methods: {

		menuItemsFn(item){
			if(item._isProcessing){
				return []
			}
			if(typeof this.menuItems === "function"){
				return this.menuItems(item)
			}
			return this.menuItems
		},

		// getMenuItems(docItem){
		// 	console.log("AgreementTemplatePickerView: getMenuItems: ", docItem.id)
		// 	let menuItems = typeof this.menuItems === "function" ? this.menuItems(docItem) : this.menuItems
		// 	// for(let i = 0; i < menuItems.length; ++i){
		// 	// 	let item = menuItems[i]
		// 	// 	if(item.action === MenuAction.EDIT){
		// 	// 		this.$set(menuItems, i, MenuItem.createViewItem("View Template"))
		// 	// 	}
		// 	// }
		// 	return menuItems
		// },

		agreementsPagerTemplateProvider() {
			let dataFilter = new DataFilterOrderBy()
			return this.dataManager.getDocSignTemplateListPager(dataFilter)
			// return this.$dataManager.getAgreementTemplateListPager()
		},

		async menuItemClicked(action, item) {
			console.log("menuItemClicked: ", action, item)
			switch (action) {
				case MenuAction.COPY:
					return this.onCopyTemplateClicked(item)
				case MenuAction.SELECT:
					return this.onTemplateClicked(item)
				case MenuAction.DELETE:
					return this.onDeleteTemplateClicked(item)
				case MenuAction.EDIT:
					return this.onTemplateEditClicked(item)
				case MenuAction.RENAME:
					return this.onTemplateRenameClicked(item)
				case MenuAction.SHARE:
					return this.requestSignatureFlowHelper.templateSendForSignature(item)
				case MenuAction.LINK:
					return this.teamAssignManager.assignLegalDocToMemberPickMember(item)
			}

		},


		// loadTemplates() {
		// 	return this.progressDataLoading("Loading agreements...")
		// 		.for(_ => this.$dataManager.getDocSignTemplateList())
		// 		.then(templateList => this.templateList = templateList)
		// },
		async onTemplateClicked(template) {
			if (template._isProcessing) {
				return
			}
			let _ = this.$analyticManager.trackEvent("Agreement selected", this.analyticsPropsMethod())

			console.log("template.isEditable = ", template.isEditable, ", template = ", template)
			if (template.isEditable) {
				await this.showEditTemplateDialog(template)
			} else {
				await this.viewTemplateDialog(template)
			}
		},


		async onTemplateRenameClicked(item) {
			let newName = await textInputDialog({
				title: "Rename Agreement",
				message: "Enter new name",
				defaultValue: item.name,
				validatorFn: (value) => {
					if (!value) {
						return "Name can't be empty"
					}
					if(!value.endsWith(".pdf"))	{
						return "Name must end with .pdf"
					}
				}
			})

			if (newName && newName !== item.name) {
				let newItem = await this.handleAsync(() => this.$dataManager.apiPostRenameContractTemplate({
					ownerId: this.ownerProfile.id,
					template: item,
					newName
				}))
				if (newItem) {
					this.$refs.pagerListLayout.notifyElementUpdated(newItem)
				}
			}

		},

		onTemplateEditClicked(template) {
			// if(!template.isEditable){
			// 	return this.showNonEditableWarningDialog("edited")
			// }
			let _ = this.$analyticManager.trackEvent("Agreement edit clicked", this.analyticsPropsMethod())
			// console.log("onTemplateClicked: template = ", template)
			this.showEditTemplateDialog(template)
		},

		async onCopyTemplateClicked(template){
			if(!template.isEditable){
				return this.showNonEditableWarningDialog("copied")
			}
			let _ = this.$analyticManager.trackEvent("Agreement duplicated", this.analyticsPropsMethod())
			let newTemplate = await this.handleAsync(() => this.$dataManager.apiPostDuplicateContractTemplate({
				ownerId: this.ownerProfile.id,
				template,
			}))
			if (newTemplate) {
				this.$refs.pagerListLayout.notifyElementAdded(newTemplate)
			}
		},

		async showNonEditableWarningDialog(verb){
			return messageDialog({
				title: "This document is not editable",
				message: `This document is predefined and can't be ${verb}`
			})
		},

		async onDeleteTemplateClicked(template) {
			if(!template.isEditable){
				return this.showNonEditableWarningDialog("deleted")
			}

			let res = await deleteConfirmDialog({itemName: "legal document"})
			if (!res) {
				return
			}
			// console.log("onDeleteTemplateClicked: ", template)
			let _ = this.$analyticManager.trackEvent("Agreement deleted", this.analyticsPropsMethod())
			res = await this.handleAsync(() => this.$dataManager.apiPostDeleteContractTemplate({
				ownerId: this.ownerProfile.id,
				template,
			}))
			if (res) {
				this.$refs.pagerListLayout.notifyElementDeleted(template)
			}
		},

		async onFileLoaded(qwoachFile, data) {
			if(this.templateProcessingInProgress){
				return
			}
			let file = qwoachFile._file
			let fileName = file.name
			// console.log("data = ", data, ", fileName = ", fileName)
			this.templateProcessingInProgress = true
			let dummyTemplate = new DocSignTemplateItem()
			dummyTemplate.name = fileName
			dummyTemplate._isProcessing = true
			this.$refs.pagerListLayout.notifyElementAdded(dummyTemplate)

			try {
				let contractTemplate = await this.$dataManager.apiPostCreateContractTemplate({
					data: data,
					fileName: fileName,
					ownerId: this.ownerProfile.id,
				})
				if(!this.isOwner){
					await this.teamAssignManager.updateMemberStatsLegalDocsTemplateCount(this.userProfile.id, 1)
				}
				this.templateProcessingInProgress = false
				this.$refs.pagerListLayout.notifyElementDeleted(dummyTemplate)
				this.$refs.pagerListLayout.notifyElementAdded(contractTemplate)

				// console.log("contractTemplate = ", contractTemplate)
				let _ = this.$analyticManager.trackEvent("Agreement added", this.analyticsPropsMethod())
				await this.showEditTemplateDialog(contractTemplate)
			} catch (error) {
				this.templateProcessingInProgress = false
				this.$refs.pagerListLayout.notifyElementDeleted(dummyTemplate)
				this.handleError(error)
			}
		},

		async showEditTemplateDialog(template) {
			template.setCoachDateSignedNow()
			let templateLocal = await editContractDialog({
				template: template,
				readonly: !template.isEditable
			})
			if(templateLocal){
				this.$refs.pagerListLayout.notifyElementUpdated(templateLocal)
			}
		},
		async viewTemplateDialog(template) {
			template.setCoachDateSignedNow()
			await editContractDialog({
				template: template,
				readonly: true
			})
		},

		analyticsPropsMethod() {
			return {
				category: "Agreement template list screen",
				...this.analyticsProps
			}
		}
	},

	computed: {
		templateProcessingInProgress: {
			get: function () {
				return this.templateProcessingInProgressData
			},
			set: function (val) {
				this.templateProcessingInProgressData = val
				// console.log("templateProcessingInProgress changed")
				this.$emit("loadingStateChanged", val)
			}
		}

	}
}
</script>

<style lang="scss">

</style>
